import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative mx-auto mb-5 max-w-[1366px] py-5 lg:mb-12 lg:py-20 lg:pl-15',
    title:
      'relative z-1 mb-3 px-5 text-[18px] leading-[1.2] font-light tracking-[0.08em] uppercase max-lg:text-center lg:mb-6 lg:max-w-[442px] lg:px-0 lg:text-[32px] lg:tracking-[0.1em]',
    carousel: 'relative z-1 [--slide-spacing:0px] lg:[--slide-spacing:20px]',
    productCard: 'ml-4 w-[295px] lg:ml-0',
    glass:
      "relative mb-4 block overflow-hidden rounded-[20px] border border-white/80 bg-white/20 shadow-[inset_0_6px_28px_rgba(255,255,255,0.12),inset_0_-6px_28px_rgba(0,0,0,0.04)] backdrop-blur-xl backdrop-saturate-150 before:absolute before:inset-x-0 before:top-0 before:h-[55%] before:bg-gradient-to-b before:from-white/30 before:to-transparent before:content-[''] after:absolute after:inset-x-0 after:bottom-0 after:h-[40%] after:bg-gradient-to-t after:from-white/20 after:to-transparent after:content-['']",
    productImage: 'relative z-1 mx-auto block h-[310px] w-full object-contain',
    content: 'flex flex-col gap-2',
    heading: 'text-base leading-[1.3] font-semibold text-[#24233D]',
    text: 'min-h-[42px] text-sm leading-[1.3] font-light text-[#24233D]',
    action: 'flex items-center justify-between gap-3 lg:mt-1',
    price: 'items-baseline',
    priceValue:
      'font-(family-name:--font-source-serif-4) text-[22px] leading-[1.2]',
    priceOld: 'text-sm leading-[1.2] text-[#898989]',
    button:
      'cursor-pointer pr-5 text-[#24233D] transition-opacity hover:opacity-70',
    imageWrapper:
      'absolute inset-y-0 -right-100 max-[1100px]:hidden xl:-right-64',
    image: 'relative top-3 h-full w-auto object-contain object-bottom',
    semibold: 'font-semibold',
    arrowPrev: 'left-0 text-[#24233D]',
    arrowNext: 'right-0 text-[#24233D]'
  }
});
